import { useSelector } from 'react-redux';
import { CommentListItem } from './CommentListItem';
import { CommentForm } from './CommentForm';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { Loading } from 'app/components/Loading';

/**
 * 댓글을 목록을 가져와서 보여준다
 * @param {*} type 원글의 유형
 * @param {*} root 원글의 정보 주로 id값을 가져온다.
 * @param {*} readOnly 삭제등의 이유로 더이상 조작을 막을경우
 * @returns 
 */
export const CommentList = ({ type, root, readOnly = false }) => {
    const auth = useSelector(state => state.auth);
    
    const { data:commentList, isFetching, isError, error } = useQuery({
        queryKey:['comment/list', type, root.id],
        queryFn:()=>Api.get(`/api/comment/list/${type}/${root.id}`),
        refetchOnMount:'always'
    });
    

    if( isError ) return <div className='no_data'>{createFetchErrorMessage(error).message}</div>
    //noToggle
    return (
        <div className="reply_area reply_list">
            <div className="reply_list reply_group">
                {auth.authenticated && !readOnly &&
                    <CommentForm mode="create" type={type} root={root} placeholder="댓글을 적어보세요." />
                }
                { commentList?.data?.list.length === 0 && <div className="no_data"><p>등록된 댓글이 없습니다.</p></div>}
                { commentList?.data?.list.map((comment) => {
                        return <CommentListItem key={comment.id} comment={comment} root={root} type={type} readOnly={readOnly} />
                    })
                }

                <Loading overlay={true} active={isFetching} />
            </div>
        </div>
    );
};